// src/slices/branchesSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PendingState {
  isPending: boolean;
}

const initialState: PendingState = {
  isPending: false
};

const PendingSlice = createSlice({
  name: 'pendingState',
  initialState,
  reducers: {
    updateIsPending: (state: PendingState, action: PayloadAction<boolean>) => {
      state.isPending = action.payload;
    }
  }
});

export const { updateIsPending } = PendingSlice.actions;
export default PendingSlice.reducer;
